import { FC } from 'react';
import Link from 'next/link';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { hideImgOnError } from '@/helpers/helpers';
import CoverSticker from '../cover-sticker/CoverSticker';
import styles from './BookCardImg.module.scss';

interface IBookCardImg {
  bookFullAlias?: string;
  title: string;
  coverId: number;
  bookId: number;
  extraClassName?: string;
  isPodcast?: boolean;
  freeVersion?: number;
  type?: string;
  retelling?: boolean;
  draft?: boolean;
}

const BookCardImg: FC<IBookCardImg> = ({ bookFullAlias, coverId, title, bookId, extraClassName, isPodcast, freeVersion, type, retelling, draft }) => {
  const getCardClassNames = () => (extraClassName ? `${styles.imgWrap} ${styles[`${extraClassName}`]}` : styles.imgWrap);

  return (
    <>
      <div className={getCardClassNames()}>
        {!!bookFullAlias ? (
          <Link prefetch={false} href={bookFullAlias} className={styles.imgLink}>
            <img className={styles.img} width="206" height="290" src={`${DEV_ABSOLUTE_URL}/covers_200/${coverId}.jpg`} alt={title} onError={hideImgOnError} />
          </Link>
        ) : (
          <img className={styles.img} width="206" height="290" src={`${DEV_ABSOLUTE_URL}/covers_200/${coverId}.jpg`} alt={title} onError={hideImgOnError} />
        )}

        <div className={styles.imgWrap__stiker}>
          {!!freeVersion && freeVersion > 0 && type !== 'pdf' && <CoverSticker name="Полная версия" extraClassName="coverSticker_full" />}
          {draft && <CoverSticker name="Черновик" extraClassName="coverSticker_draft" />}
          {retelling && <CoverSticker name="Краткий пересказ" extraClassName="coverSticker_retelling" />}
        </div>

      </div>
    </>
  );
};

export default BookCardImg;
